import React, { useMemo } from "react";

/**
 * ParticleDots — sparse drifting dots for ambient AI feel.
 * Subtle by design — should never compete with content.
 */
const ParticleDots = ({ count = 16 }) => {
  const dots = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: `${(i * 53.3 + 7) % 100}%`,
        top: `${(i * 31.7 + 11) % 100}%`,
        delay: `${(i * 0.7) % 8}s`,
        duration: `${10 + (i * 1.3) % 8}s`,
      })),
    [count],
  );

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true">
      {dots.map((dot) => (
        <span
          key={dot.id}
          className="particle-dot"
          style={{
            left: dot.left,
            top: dot.top,
            animationDelay: dot.delay,
            animationDuration: dot.duration,
          }}
        />
      ))}
    </div>
  );
};

export default ParticleDots;
